import { QueryClient, useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';

import {
  ASSET_SLOT_EVENT_QUERY_KEY,
  ASSET_SLOT_EVENT_URL,
  ASSET_SLOT_QUERY_KEY,
  EVENT_BY_ID_QUERY_KEY
} from '@/constants';
import { apiUrl } from '@/helpers';
import { AssetSlotEvent, ErrorResponse, Options } from '@/types';

export const assetSlotEventEndpoints = {
  getAssetSlotEvent: (id: number) => axios.get(`${apiUrl()}${ASSET_SLOT_EVENT_URL}/${id}`),
  createAssetSlotEvent: (payload: AssetSlotEvent) =>
    axios.post(`${apiUrl()}${ASSET_SLOT_EVENT_URL}`, payload),
  updateAssetSlotEvent: (payload: AssetSlotEvent) =>
    axios.put(`${apiUrl()}${ASSET_SLOT_EVENT_URL}`, payload),
  deleteAssetSlotEvent: (id: number) => axios.delete(`${apiUrl()}${ASSET_SLOT_EVENT_URL}/${id}`)
};
export const useGetAssetSlotEventQuery = (id: number | undefined, options?: Options) => {
  return useQuery(
    [ASSET_SLOT_EVENT_QUERY_KEY, { id }],
    () => assetSlotEventEndpoints.getAssetSlotEvent(id as number),
    {
      enabled: !!id,
      onError: (error) => {
        options?.onError(error as ErrorResponse);
      }
    }
  );
};

export const useCreateAssetSlotEventMutation = (queryClient: QueryClient, options: Options) => {
  return useMutation(assetSlotEventEndpoints.createAssetSlotEvent, {
    onSuccess: () => {
      options.onSuccess();
      queryClient.invalidateQueries([EVENT_BY_ID_QUERY_KEY]);
    },
    onError: (error) => {
      options.onError(error as ErrorResponse);
    }
  });
};

export const useUpdateAssetSlotEventMutation = (queryClient: QueryClient, options: Options) => {
  return useMutation(assetSlotEventEndpoints.updateAssetSlotEvent, {
    onSuccess: () => {
      options.onSuccess();
      queryClient.invalidateQueries([ASSET_SLOT_QUERY_KEY]);
    },
    onError: (error) => {
      options.onError(error as ErrorResponse);
    }
  });
};

export const useDeleteAssetSlotEventMutation = (queryClient: QueryClient, options: Options) => {
  return useMutation(assetSlotEventEndpoints.deleteAssetSlotEvent, {
    onSuccess: () => {
      options.onSuccess();
      queryClient.invalidateQueries([EVENT_BY_ID_QUERY_KEY]);
    },
    onError: (error) => {
      options.onError(error as ErrorResponse);
    }
  });
};
